import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Home, Search, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      
      <main className="flex-grow flex items-center justify-center py-16">
        <div className="text-center px-4">
          {/* 404 Illustration */}
          <div className="relative mb-8">
            <span className="text-[180px] font-bold text-gray-100 leading-none">404</span>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-6xl">🐾</div>
            </div>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            Oups ! Page introuvable
          </h1>
          <p className="text-gray-500 mb-8 max-w-md mx-auto">
            La page que vous recherchez semble avoir disparu comme un chat dans la nuit. 
            Elle a peut-être été déplacée ou n'existe plus.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/">
              <Button className="bg-green-500 hover:bg-green-600 text-white px-6">
                <Home className="w-4 h-4 mr-2" />
                Retour à l'accueil
              </Button>
            </Link>
            <Link to="/recherche">
              <Button variant="outline" className="px-6">
                <Search className="w-4 h-4 mr-2" />
                Rechercher un vétérinaire
              </Button>
            </Link>
          </div>
          
          {/* Helpful links */}
          <div className="mt-12 pt-8 border-t max-w-md mx-auto">
            <p className="text-sm text-gray-500 mb-4">Pages utiles :</p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <Link to="/conseils" className="text-green-600 hover:underline">Conseils</Link>
              <Link to="/espace-patient" className="text-green-600 hover:underline">Espace Patient</Link>
              <Link to="/espace-veterinaire" className="text-green-600 hover:underline">Espace Vétérinaire</Link>
              <Link to="/contact" className="text-green-600 hover:underline">Contact</Link>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFoundPage;
